import { initialStateLoanPurpose } from '@commblades/commblades';

import { LOAN_PURPOSE_ID } from '../../types';

const { applicationRoot } = window.NetBank;

export type LoanPurposeCardRaw = {
    id: number;
    description: string;
    name: string;
    pictogram: string;
    pictogramTheme: string;
    title: string;
    value: string;
}

export const LoanPurposePictogramMap = [
    {
        loanPurposeId: LOAN_PURPOSE_ID.CAR,
        pictogram: 'StandardVehicle64',
    },
    {
        loanPurposeId: LOAN_PURPOSE_ID.RENOVATIONS,
        pictogram: 'HomeBuying64',
    },
    {
        loanPurposeId: LOAN_PURPOSE_ID.DEBT_CONSOLIDATION,
        pictogram: 'DebtConsolidation64',
    },
    {
        loanPurposeId: LOAN_PURPOSE_ID.GREEN_PURCHASES,
        pictogram: 'FinancialPlanning64',
    },
    {
        loanPurposeId: LOAN_PURPOSE_ID.PERSONAL_GOODS,
        pictogram: 'Celebration64',
    },
    {
        loanPurposeId: LOAN_PURPOSE_ID.TRAVEL,
        pictogram: 'Travel64',
    },
    {
        loanPurposeId: LOAN_PURPOSE_ID.MEDICAL_AND_DENTAL,
        pictogram: 'Health64',
    },
    {
        loanPurposeId: LOAN_PURPOSE_ID.OTHERS,
        pictogram: 'Help64',
    },
];

const loanPurposesState = {
    ...initialStateLoanPurpose,
    apiEndpoints: {
        // TODO: get endpoint from preload data
        getLoanPurposeApiUrl: `${applicationRoot}getloanpurposes`,
    },
};

export default loanPurposesState;
